import classNames from 'classnames';

import styles from './ToolbarSectionTitle.module.scss';

const ToolbarSectionTitle = ({ children, className }) => {
  return (
    <div
      className={classNames([styles.container, className])}
      itemScope
      itemType='https://schema.org/Text'
    >
      <div className={styles.title}>
        <strong>{children}</strong>
      </div>
    </div>
  );
};

export default ToolbarSectionTitle;
